import { ValueOf } from '../utils/fileUtils';
import { DocumentType } from '../utils/formUtils';

export const DOCUMENT_STATUS = {
  metaDataCreated: 'METADATA_CREATED',
  uploadCompleted: 'UPLOAD_COMPLETED',
  uploadFailed: 'UPLOAD_FAILED',
  urlGenerated: 'URL_GENERATED',
  smsSent: 'SMS_SENT',
} as const;

export type Document = {
  sessionId: number;
  receptionNo: string;
  documentStatus: ValueOf<typeof DOCUMENT_STATUS>;
  id: string;
  name: string;
  guidelines: string;
  formId: string;
  physicalCopyRequired: boolean;
  customerUploadRequired: boolean;
  uploadStage: 'USER' | 'CUSTOMER';
};

export type Session = {
  documents: Document[];
  sessionId: number;
};

export type SessionParams = {
  receptionNo: string;
  formIds: string[];
};

export type UpdateSessionParams = {
  sessionId: number;
  formIds: string[];
  receptionNo?: string;
};

export type SessionGetCMXUrlParams = {
  sessionId: number;
  document: DocumentType;
};

export type SessionCmxUrl = {
  cmxUploadUrl: string;
  headers: Record<string, string>;
  cmxDocumentId: string;
};

export const DOCUMENT_UPLOAD_PROGRESS = {
  metaDataCreated: 'METADATA_CREATED',
  inProgress: 'UPLOAD_IN_PROGRESS',
  completed: 'UPLOAD_COMPLETED',
} as const;
